import { EaseChatClient } from '@/IM/initwebsdk'
import { useImConversationStore  } from '@/store'

export const imConnectListener = () => {
    // 监听连接环信状态
    const mountConnectEventListener = () => {
        EaseChatClient.addEventHandler('connection', {
            // 登录环信
            onConnected: () => {
                // 获取会话列表
                useImConversationStore().getConversationList()
                console.log('环信登录成功')
            },
            // 退出环信
            onDisconnected: () => {
                console.log('环信退出成功')
            },
            // 本机网络连接成功
            onOnline: () => {
                
            }, 
            // 本机网络连接掉线
            onOffline: () => {
                
            }, 
            // 连接错误
            onError: (error) => {
                console.error('----连接错误----', error)
            }
        })
    }
    return {
        mountConnectEventListener,
    }
}
